module.exports = __webpack_public_path__ + "svg/ep-man-doc.823f32d.svg";